/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_ACCESS_SUCCESS,
  LOAD_ACCESS_ERROR,
  LOAD_MENU_LIST_SUCCESS,
  LOAD_MENU_LIST_ERROR,
  LOAD_DASHBOARD_TRANSACTIONS_SUCCESS,
  LOAD_DASHBOARD_TRANSACTIONS_ERROR,
  LOAD_USER_ROLE_LIST_SUCCESS,
  LOAD_USER_ROLE_LIST_ERROR,
  LOAD_USER_PERMISSON_LIST_ERROR,
  LOAD_USER_PERMISSON_LIST_SUCCESS,
  LOAD_INFO_LIST_SUCCESS,
  LOAD_USER_ACCESS_SUCCESS,
  LOAD_USER_ACCESS_ERROR,
  LOAD_USER_MENU_SUCCESS,
  LOAD_USER_MENU_ERROR
  //  LOAD_INFO_LIST_ERROR
} from "./constants";

const initialState = {
  access_list: [],
  menu_list: [],
  dashboard_transactions: [],
  user_role_list: [],
  user_permission_list: [],
  info_List: [],
  userAccess_list: [],
  user_menu_list: []
};

const Reducer = (
  state = initialState,
  {
    type,
    access_list,
    menu_list,
    user_permission_list,
    dashboard_transactions,
    user_role_list,
    info_List,
    userAccess_list,
    user_menu_list
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_ACCESS_SUCCESS:
        draft.access_list = access_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_MENU_LIST_SUCCESS:
        draft.menu_list = menu_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DASHBOARD_TRANSACTIONS_SUCCESS:
        draft.dashboard_transactions = dashboard_transactions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_USER_ROLE_LIST_SUCCESS:
        draft.user_role_list = user_role_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_USER_PERMISSON_LIST_SUCCESS:
        draft.user_permission_list = user_permission_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_INFO_LIST_SUCCESS:
        draft.info_List = info_List;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_USER_ACCESS_SUCCESS:
        draft.userAccess_list = userAccess_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_USER_MENU_SUCCESS:
        draft.user_menu_list = user_menu_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_ACCESS_ERROR:
      case LOAD_DASHBOARD_TRANSACTIONS_ERROR:
      case LOAD_MENU_LIST_ERROR:
      case LOAD_USER_ROLE_LIST_ERROR:
      case LOAD_USER_PERMISSON_LIST_ERROR:
      case LOAD_USER_MENU_ERROR:
      case LOAD_USER_ACCESS_ERROR:
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
